<section class="content" id="contentPrint">
<!-- 
  <header id="header">
     <header-relatorio></header-relatorio>
  </header> -->

  <main id="content" #contentPrint>

    <header>
      <main>
        <section class="header-relatorio">
            <div class="img-logo" ></div>
              <img style="width: 100% !important;" id="background" src="../../../../../assets/img/png/Cabeçalho.png" />
              <img style="width: 8rem; position: relative; bottom: 48px;" src="../../../../assets/img/png/logo-atualizada.PNG" /> 
              <!-- <img src="../../../../../assets/img/png/logo-atualizada" />  -->
        </section>
        <section>
            <div class="ans text-right" style="position: absolute; width: 69%; top: 82px;">
                <span class="logo-ans" style="background: black; color: white; padding: 0.25rem;">
                    ANS - n° 355151
                </span>
            </div>
        </section>
    </main>
    </header>

    <h3 class="mt-3">Guia Rede Credenciada</h3>
    <section class="row">
      <div class="col-2 px-1 mt-3">
        <span class="title-form">
          <b>Cidade</b>:
        </span>
        <span class="content-form-result">
          {{formulario.cidade ?? 'Todos' }}
        </span>
      </div>
      <div class="col-5 px-1 mt-3">
        <span class="title-form">
          <b>Endereço, Telefone ou Site</b>:
        </span>
        <span class="content-form-result">
          {{formulario.endereco ?? 'Todos'}}
        </span>
      </div>
      <div class="col-5 px-1 mt-3">
        <span class="title-form">
          <b>Nome, CNPJ, Registro Profissional</b>:
        </span>
        <span class="content-form-result">
          {{formulario.nome ?? 'Todos'}}
        </span>
      </div>
    </section>
    <section class="row">
      <div class="col-2 px-1 mt-3">
        <span class="title-form">
          <b>Especialidade</b>:
        </span>
        <span class="content-form-result">
          {{formulario.especialidades ?? 'Todos' }}
        </span>
      </div>
      <div class="col-2 px-1 mt-3">
        <span class="title-form">
          <b>Bairro</b>:
        </span>
        <span class="content-form-result">
          {{formulario.bairro ?? 'Todos' }}
        </span>
      </div>
      <div class="col-4 px-1 mt-3">
        <span class="title-form">
          <b>Tipo de Estabelecimento</b>:
        </span>
        <span class="content-form-result">
          {{formulario.tipoEstabelecimento ?? 'Todos' }}
        </span>
      </div>
      <div class="col-4 px-1 mt-3">
        <span class="title-form">
          <b>Plano - Registro (ANS)</b>:
        </span>
        <span class="content-form-result">
          {{formulario.plano ?? 'Todos' }}
        </span>
      </div>
    </section>
    <div class="content-aviso">
      <h4>
        <b>Atenção</b>
      </h4>
      <p class="aviso-mensagem">
        Esta é uma impressão para uso breve, alterações podem acontecer, dessa forma tornando os
        dados aqui contidos não mais precisos. Nessa impressão serão mostrados os primeiros <b>50 resultados da
          pesquisa!</b>.
      </p>
    </div>
    <section>
      <span class="title-content">Prestadores Ativos ({{listaCredenciados?.totalFiltered}})</span>
      <section class="content-resultado" *ngFor="let credenciado of listaCredenciados.items">
        <div>
          <span class="content-title">Nome: </span>
          <span>{{credenciado.tradeName}}</span>
        </div>
        <div *ngIf="credenciado.crm">
          <span class="content-title">Crm: </span>
          <span>{{credenciado.crm}}</span>
        </div>
        <div>
          <span class="content-title">Tipo de estabelecimento: </span>
          <span>{{credenciado.companyType}}</span>
        </div>
        <div *ngIf="credenciado.expertize">
          <span class="sub-title">Especialidades: </span>
          <span>{{credenciado.expertize}}</span>
        </div>
        <div>
          <span class="content-title">Telefones: </span>
          <span *ngIf="credenciado.phone && !credenciado.phone2">{{credenciado.phone | Phone}}</span>
          <span *ngIf="!credenciado.phone && credenciado.phone2">{{credenciado.phone2 | Phone}}</span>
          <span *ngIf="credenciado.phone && credenciado.phone2">
            {{credenciado.phone | Phone}}, {{credenciado.phone2 | Phone}}
          </span>
          <span *ngIf="!credenciado.phone && !credenciado.phone2">
            Telefone(s) não localizado(s)
          </span>
        </div>
        <div>
          <span class="content-title">Endereço: </span>
          <span>
            {{credenciado.address | uppercase}}, {{credenciado.addressNumber | uppercase}},
            {{credenciado.neighborhood | uppercase}}, {{credenciado.city | uppercase}}, {{credenciado.state |
            uppercase}} - CEP {{credenciado.cep }}
          </span>
        </div>
      </section>
    </section>
    <section class="mt-2">
      <span class="title-content">Referenciados ({{listaReferenciados?.totalFiltered}})</span>
      <p></p>
    </section>
    <section class="mt-2">
      <span class="title-content">Descredenciados () </span>
      <p></p>
    </section>
    <section class="mt-2 ml-1">
      <span class="title-content">Próximos 30 dias ({{listaDescredenciados?.ultimoMes?.totalFiltered}})</span>
      <p></p>
    </section>
    <section class="mt-2 ml-1">
      <span class="title-content">Últimos 6 meses ({{listaDescredenciados?.ultimoSemestre?.totalFiltered}})</span>
      <p></p>
    </section>

<footer class="card-legenda row" id="footer">
  <table class="col-sm-12 col-md-12 col-lg-6 col-xl-6 letter-content-padrao page-break">
    <tr>
      <td>
        <img class="imagem-legenda" src="../../../../assets/img/png/rede-credenciada/apalc.png">
      </td>
      <td>
        <p class="descricao-legeda">Padrão Nacional de Qualidade</p>
      </td>
    </tr>
    <tr>
      <td>
        <img class="imagem-legenda" src="../../../../assets/img/png/rede-credenciada/adicq.png">
      </td>
      <td>Padrão Nacional de Qualidade</td>
    </tr>
    <tr>
      <td>
        <img class="imagem-legenda" src="../../../../assets/img/png/rede-credenciada/aona.png">
      </td>
      <td>Padrão Nacional de Qualidade</td>
    </tr>
    <tr>
      <td>
        <img class="imagem-legenda" src="../../../../assets/img/png/rede-credenciada/acba.png">
      </td>
      <td>Padrão Internacional de Qualidade</td>
    </tr>
    <tr>
      <td>
        <img class="imagem-legenda" src="../../../../assets/img/png/rede-credenciada/aiqg.png">
      </td>
      <td>Padrão Internacional de Qualidade</td>
    </tr>
    <tr class="not-mobile-tablet">
      <td>
        <img class="imagem-legenda-letter" src="../../../../assets/img/png/rede-credenciada/n.png">
      </td>
      <td>
        <p class="descricao-legeda">Comunicação de eventos adversos</p>
      </td>
    </tr>
    <tr class="not-mobile-tablet">
      <td>
        <img class="imagem-legenda-letter" src="../../../../assets/img/png/rede-credenciada/p.png">
      </td>
      <td>Profissional com especialização</td>
    </tr>
  </table>
  <table class="col-sm-12 col-md-12 col-lg-6 col-xl-6 letter-content page-break">
    <tr>
      <td>
        <img class="imagem-legenda-letter" src="../../../../assets/img/png/rede-credenciada/n.png">
      </td>
      <td>Comunicação de eventos adversos</td>
    </tr>
    <tr>
      <td>
        <img class="imagem-legenda-letter" src="../../../../assets/img/png/rede-credenciada/p.png">
      </td>
      <td>Profissional com especialização</td>
    </tr>
    <tr>
      <td>
        <img class="imagem-legenda-letter" src="../../../../assets/img/png/rede-credenciada/r.png">
      </td>
      <td>Profissional com residência</td>
    </tr>
    <tr>
      <td>
        <img class="imagem-legenda-letter" src="../../../../assets/img/png/rede-credenciada/e.png">
      </td>
      <td>Título de especialista</td>
    </tr>
    <tr>
      <td>
        <img class="imagem-legenda-letter" src="../../../../assets/img/png/rede-credenciada/q.png">
      </td>
      <td>Qualidade monitorada</td>
    </tr>
    <tr>
      <td>
        <img class="imagem-legenda-letter" src="../../../../assets/img/png/rede-credenciada/g.png">
      </td>
      <td>Certificações de Entidades Gestoras de Outros Programas de Qualidade</td>
    </tr>
    <tr>
      <td>
        <img class="imagem-legenda-letter" src="../../../../assets/img/png/rede-credenciada/i.png">
      </td>
      <td>Certificação ISO 9001</td>
    </tr>
    <tr>
      <td>
        <img class="imagem-legenda-letter" src="../../../../assets/img/png/rede-credenciada/d.png">
      </td>
      <td>Profissional com Doutorado ou Pós-Doutorado</td>
    </tr>
    <tr>
      <td>
        <img class="imagem-legenda-letter" src="../../../../assets/img/png/rede-credenciada/m.png">
      </td>
      <td>Mestrado em saúde reconhecido pelo MEC</td>
    </tr>
  </table>
</footer>

</main>
</section>